import {
  type RemoteConfigResponse,
  apiRoutes,
  type DefaultQueryError,
  getRemoteConfigFn,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetRemoteConfig = (
  opts?: Omit<
    UseQueryOptions<RemoteConfigResponse, DefaultQueryError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<RemoteConfigResponse, DefaultQueryError>({
    queryKey: [apiRoutes.firebase.remoteConfig],
    queryFn: getRemoteConfigFn,
    ...opts,
  });
